import { db } from './../../../config/Fire';
import * as Constants from './../../../constants/nodes_database';

export const SET_SERVICES = 'SET_SERVICES';

const setServices = payload => ({ type: SET_SERVICES, payload });

export const setServicesToState = payload => {
    return dispatch => {
        return db.ref(`${Constants.SERVICES}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists() && snapshot.val() !== null) {
                    var services = {};
                    snapshot.forEach(function(service) {
                        var serviceVal = service.val();
                        services[serviceVal.id] = serviceVal.name;
                    });
                    dispatch(setServices(services));
                } else {
                    console.log("snapshot: " + snapshot);
                    dispatch(setServices(null));
                }
            })
            .catch(err => {
                console.log ('Error getting user: ', err);
                dispatch(setServices(null));
        });
    };
};